module.exports = __webpack_public_path__ + "img/nobother.a26ca012.svg";